module.exports = import("https://cdn.jsdelivr.net/gh/whatsauth/js@0.2.1/whatsauth.js");;